<script setup>
  import { onMounted } from 'vue';
  import { useSheetController } from "@/composables/useSheetsController";
  import Icon from '@/components/icons/Icon.vue';
  
  const handleLegendClick = (e) => {
    useSheetController.toggleSheet('info', 'dsat-operating-conditions', true, false, { content: e.target.dataset.content });
  }
</script>
<template>
  <div class="jwx-dsat-legend">
    <div class="jwx-dsat-legend__content">
      <div class="jwx-dsat-legend__icon">
        <Icon name="dsat" class="jwx-dsat-legend__svg" />
      </div>
      <ul class="jwx-dsat-legend__keys">
        <li class="jwx-dsat-legend__key">
          <div class="jwx-dsat-legend__value" data-legend="dsat" data-value="normal">
            <button
            type="button"
            @click.prevent="handleLegendClick"
            class="jwx-dsat-legend__label"
            data-content="dsat-normal"
            >
              <span class="jwx-dsat-legend__label-text">Normal</span>
              <Icon name="info-solid" class="jwx-dsat-legend__label-icon" />
            </button>
          </div>
        </li>
        <li class="jwx-dsat-legend__key">
          <div class="jwx-dsat-legend__value" data-legend="dsat" data-value="elevated">
            <button
            type="button"
            @click.prevent="handleLegendClick"
            class="jwx-dsat-legend__label"
            data-content="dsat-elevated"
            >
              <span class="jwx-dsat-legend__label-text">Elevated</span>
              <Icon name="info-solid" class="jwx-dsat-legend__label-icon" />
            </button>
          </div>
        </li>
        <li class="jwx-dsat-legend__key">
          <div class="jwx-dsat-legend__value" data-legend="dsat" data-value="extreme">
            <button
            type="button"
            @click.prevent="handleLegendClick"
            class="jwx-dsat-legend__label"
            data-content="dsat-extreme"
            >
              <span class="jwx-dsat-legend__label-text">Extreme</span>
              <Icon name="info-solid" class="jwx-dsat-legend__label-icon" />
            </button>
          </div>
        </li>
        <li class="jwx-dsat-legend__key">
          <div class="jwx-dsat-legend__value" data-legend="dsat" data-value="no-data">
            <p class="jwx-dsat-legend__label"><span class="jwx-dsat-legend__label-text">No Data</span></p>
          </div>
        </li>
      </ul>
      <div class="jwx-dsat-legend__action">
        <button
          type="button"
          @click.prevent="handleLegendClick"
          class="jwx-dsat-legend__action-button"
          data-content="dsat-disclaimer"
        >
          <Icon name="info-solid" class="jwx-dsat-legend__action-icon" />
        </button>
      </div>
    </div>
  </div>
</template>